import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(pages)/forgot-password/client-page.js");
